export const REFRESH_TRACKING_SUCCESS = 'REFRESH_TRACKING_SUCCESS';

export const refreshTrackingSuccess = (jobGuid, message) => ({
  type: REFRESH_TRACKING_SUCCESS,
  jobGuid,
  message,
});
